<dx-popup #popupEmailFax class="popup" [width]="300" [height]="150" [showTitle]="true" [dragEnabled]="true"
          [closeOnOutsideClick]="false" [showCloseButton]="false" [(visible)]="popupVisible" (onTitleRendered)="onTitleRendered($event)">
    <dxi-toolbar-item location="before">
        <h3 style="margin: 2px 10px">{{'Send ' + (this.type === 'email' ? 'Email' : 'Fax')}}</h3>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Close" (click)="close()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Send" (click)="save()"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" style="height: 100%">
        <dx-scroll-view [showScrollbar]="'onScroll'">
        <form [formGroup]="emailFaxForm" style="height: 100%">
            <div class="content-block" fxLayout="column" fxLayoutAlign="space-between stretch">
                <div fxLayout="row" class="dx-field" *ngIf="type === 'email'">
                    <div class="dx-field-label" style="width: 20% !important;">To <span
                        class="ocl-required-indicator">*</span></div>
                    <div class="dx-field-value" style="width: 100% !important;">
                        <dx-text-box formControlName="email">
                            <dx-validator validationGroup="emailValidationGroup" *ngIf="type === 'email'">
                                <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
                                <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div fxLayout="row" class="dx-field" *ngIf="type === 'fax'">
                    <div class="dx-field-label" style="width: 20% !important;">To <span
                        class="ocl-required-indicator">*</span></div>
                    <div class="dx-field-value" style="width: 100% !important;">
                        <dx-text-box formControlName="fax" mask="000-000-0000" maskInvalidMessage="Fax is invalid">
                            <dx-validator validationGroup="faxValidationGroup" *ngIf="type === 'fax'">
                                <dxi-validation-rule type="required" message="Fax is required"></dxi-validation-rule>
                                <dxi-validation-rule type="pattern" [pattern]="faxPattern"
                                                     message="Fax is invalid"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </div>
        </form>
        </dx-scroll-view>
    </div>
</dx-popup>
<dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>
